import { DropdownMenuItem } from "@radix-ui/react-dropdown-menu";
import { Star } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import FluidImage from "@/components/images/fluid-image";
import { FLUID_CDN_URL } from "@/lib/constants";

export default function EllipsesDropdown({
  onDelete,
  onEdit,
  onMakeDefault,
  editLabel = "Edit",
  deleteLabel = "Delete",
  makeDefaultLabel = "Make Default",
  disabled = false,
}: {
  onDelete?: () => void;
  onEdit?: () => void;
  onMakeDefault?: () => void;
  editLabel?: string;
  deleteLabel?: string;
  makeDefaultLabel?: string;
  disabled?: boolean;
}) {
  if (disabled) {
    return (
      <Button
        variant="ghost"
        disabled
        className="cursor-not-allowed opacity-50"
      >
        <FluidImage
          src={`${FLUID_CDN_URL}/images/checkout/icons/ellipsis-vertical.svg`}
          alt="Vertical Ellipsis"
          width={5}
          height={5}
          className="gray-icons"
        />
      </Button>
    );
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost">
          <FluidImage
            src={`${FLUID_CDN_URL}/images/checkout/icons/ellipsis-vertical.svg`}
            alt="Vertical Ellipsis"
            width={5}
            height={5}
            className="gray-icons"
          />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="min-w-36 space-y-1 text-sm text-gray-900">
        {onEdit && (
          <>
            <DropdownMenuItem
              className="flex cursor-pointer flex-row items-center justify-between gap-3 rounded px-3 py-2 hover:bg-gray-50"
              onClick={(e) => {
                e.stopPropagation();
                onEdit?.();
              }}
            >
              <span>{editLabel}</span>
              <FluidImage
                src={`${FLUID_CDN_URL}/images/checkout/icons/pencil.svg`}
                alt="Edit"
                width={14}
                height={14}
                className="black-icons"
              />
            </DropdownMenuItem>
            <DropdownMenuSeparator />
          </>
        )}
        {onMakeDefault && (
          <>
            <DropdownMenuItem
              className="flex cursor-pointer flex-row items-center justify-between gap-3 rounded px-3 py-2 hover:bg-gray-50"
              onClick={(e) => {
                e.stopPropagation();
                onMakeDefault?.();
              }}
            >
              <span>{makeDefaultLabel}</span>
              <Star className="h-3.5 w-3.5 text-gray-700" aria-hidden />
            </DropdownMenuItem>
            <DropdownMenuSeparator />
          </>
        )}
        <DropdownMenuItem
          className="flex cursor-pointer flex-row items-center justify-between gap-3 rounded px-3 py-2 text-red-500 hover:bg-red-50"
          onClick={(e) => {
            e.stopPropagation();
            onDelete?.();
          }}
        >
          <span>{deleteLabel}</span>

          <FluidImage
            src={`${FLUID_CDN_URL}/images/checkout/icons/trash.svg`}
            alt="Delete"
            width={14}
            height={14}
            className="red-icons"
          />
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
